import React, { useMemo } from "react"

import { AddMetricsToRunButton } from "@/metrics/rerun"
import { Button, toast } from "@coval/ui"

import type { ConversationsTableResult } from "@/types/tables/ConversationsTable"

const MAX_RERUN_CALLS = 500

interface RerunMetricsButtonProps {
  selectedKeys: Set<string>
  currentData: ConversationsTableResult[]
  onSuccess?: () => void
}

export const RerunMetricsButton: React.FC<RerunMetricsButtonProps> = ({
  selectedKeys,
  currentData,
  onSuccess,
}) => {
  const selectedSimulationOutputIds = useMemo(() => {
    return currentData
      .filter(
        (item) =>
          item.simulation_output_id &&
          selectedKeys.has(item.simulation_output_id),
      )
      .map((item) => item.simulation_output_id as string)
  }, [selectedKeys, currentData])

  const exceedsLimit = selectedSimulationOutputIds.length > MAX_RERUN_CALLS

  if (exceedsLimit) {
    return (
      <Button
        type="button"
        variant="secondary"
        className="text-coval-text-muted opacity-60"
        onClick={() => {
          toast.danger({
            title: "Too many calls selected",
            description: `Please select ${MAX_RERUN_CALLS} or fewer calls to rerun metrics (${selectedSimulationOutputIds.length} selected)`,
          })
        }}
        aria-label={`Cannot rerun metrics: ${selectedSimulationOutputIds.length} calls selected, maximum is ${MAX_RERUN_CALLS}`}
      >
        Rerun Metrics ({selectedSimulationOutputIds.length})
      </Button>
    )
  }

  return (
    <AddMetricsToRunButton
      selectedSimulationOutputIds={selectedSimulationOutputIds}
      onSuccess={onSuccess}
    />
  )
}
